module.exports = {
	"title": "Books",
	"_formKey": "bookspagemasterform",
	"pageTitle": "Books",
	"link": "books",
	"books": [
		{
			"id": "74bc817f5acf74c65d14",
			"ref": "node://7ff94dad3b3d40f8b631/99f505c98cb37175bbe5/7df865401a95482cf6ba/74bc817f5acf74c65d14",
			"title": "this-strange-eventful-history",
			"qname": "o:74bc817f5acf74c65d14",
			"typeQName": "nortoncore:books"
		},
		{
			"id": "c95119b63147df8792c8",
			"ref": "node://7ff94dad3b3d40f8b631/99f505c98cb37175bbe5/7df865401a95482cf6ba/c95119b63147df8792c8",
			"title": "the-hunters",
			"qname": "o:c95119b63147df8792c8",
			"typeQName": "nortoncore:books"
		},
		{
			"id": "96075927621a502ce4cb",
			"ref": "node://7ff94dad3b3d40f8b631/99f505c98cb37175bbe5/7df865401a95482cf6ba/96075927621a502ce4cb",
			"title": "the-burning-girl",
			"qname": "o:96075927621a502ce4cb",
			"typeQName": "nortoncore:books"
		},
		{
			"id": "b7b83284c7c65d58e4b1",
			"ref": "node://7ff94dad3b3d40f8b631/99f505c98cb37175bbe5/7df865401a95482cf6ba/b7b83284c7c65d58e4b1",
			"title": "the-woman-upstairs",
			"qname": "o:b7b83284c7c65d58e4b1",
			"typeQName": "nortoncore:books"
		},
		{
			"id": "88fdeb35d5c370b8fef7",
			"ref": "node://7ff94dad3b3d40f8b631/99f505c98cb37175bbe5/7df865401a95482cf6ba/88fdeb35d5c370b8fef7",
			"title": "when-the-world-was-steady",
			"qname": "o:88fdeb35d5c370b8fef7",
			"typeQName": "nortoncore:books"
		},
		{
			"id": "03bb7dd665c07a46a1ce",
			"ref": "node://7ff94dad3b3d40f8b631/99f505c98cb37175bbe5/7df865401a95482cf6ba/03bb7dd665c07a46a1ce",
			"title": "the-emperor-s-children",
			"qname": "o:03bb7dd665c07a46a1ce",
			"typeQName": "nortoncore:books"
		},
		{
			"id": "1386945440a9338305b8",
			"ref": "node://7ff94dad3b3d40f8b631/99f505c98cb37175bbe5/7df865401a95482cf6ba/1386945440a9338305b8",
			"title": "kant-s-little-prussian-head-and-other-reasons-why-i-write",
			"qname": "o:1386945440a9338305b8",
			"typeQName": "nortoncore:books"
		},
		{
			"id": "2f713f5b50989ca19120",
			"ref": "node://7ff94dad3b3d40f8b631/99f505c98cb37175bbe5/7df865401a95482cf6ba/2f713f5b50989ca19120",
			"title": "the-last-life",
			"qname": "o:2f713f5b50989ca19120",
			"typeQName": "nortoncore:books"
		}
	],
	"_doc": "f793ead223d7463602c3",
	"attachments": {},
	"_system": {
		"deleted": false,
		"changeset": "552:2413690a073315a177f5",
		"created_on": {
			"timestamp": "16-May-2017 14:59:33",
			"year": 2017,
			"month": 4,
			"day_of_month": 16,
			"hour": 14,
			"minute": 59,
			"second": 33,
			"millisecond": 992,
			"ms": 1494946773992,
			"iso_8601": "2017-05-16T14:59:33Z"
		},
		"created_by": "sdike",
		"created_by_principal_id": "e4180bb7661ac1511f07",
		"created_by_principal_domain_id": "3d96ab762d6c9248425b",
		"modified_on": {
			"timestamp": "25-Jan-2024 17:26:29",
			"year": 2024,
			"month": 0,
			"day_of_month": 25,
			"hour": 17,
			"minute": 26,
			"second": 29,
			"millisecond": 139,
			"ms": 1706203589139,
			"iso_8601": "2024-01-25T17:26:29Z"
		},
		"modified_by": "mmcginnis",
		"modified_by_principal_id": "7683d13972fe921163df",
		"modified_by_principal_domain_id": "3d96ab762d6c9248425b",
		"previousChangeset": "551:1ca948df85192e761390",
		"edited_on": {
			"timestamp": "25-Jan-2024 17:26:29",
			"year": 2024,
			"month": 0,
			"day_of_month": 25,
			"hour": 17,
			"minute": 26,
			"second": 29,
			"millisecond": 139,
			"ms": 1706203589139,
			"iso_8601": "2024-01-25T17:26:29Z"
		},
		"edited_by": "mmcginnis",
		"edited_by_principal_id": "7683d13972fe921163df",
		"edited_by_principal_domain_id": "3d96ab762d6c9248425b",
		"rev": 552
	},
	"_statistics": {
		"a:child": 1,
		"a:child_INCOMING": 1,
		"a:has_role": 4,
		"a:has_role_INCOMING": 4,
		"a:linked": 7,
		"a:linked_INCOMING": 1,
		"a:linked_OUTGOING": 6
	},
	"insightNode": "99f505c98cb37175bbe5/7df865401a95482cf6ba/f793ead223d7463602c3",
	"status": "OK"
};


//////////////////
// WEBPACK FOOTER
// ./src/jsondata/bookspage.json
// module id = 506
// module chunks = 0